var _g, _g2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitur2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_462_20732)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 60,
    r: 60,
    fill: "#D0D1D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_462_20732)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 60,
    r: 55,
    stroke: "#D0D1D3",
    strokeWidth: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 30,
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_462_20732",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_20732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_20732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_462_20732",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_20732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_20732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_462_20732",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_462_20732",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADLUlEQVR4nO2cXW4TQRCEKyZCvHOB4FyBu0B8QfJIgFsExCn4iQUHMHJkHmxLq/F6Z6an5sez9UmtaBVNuV0e79qp9AJCCCGEEEIIIU5YAFgB+AzgJ4B/h5+fANwdfl9Sp0tuAXwHsJuobwCWhXS65BbAGtPmHGuN8yaxdLrkBfw7cGxHum9/lk63rBBnzrHeZ9Lpli+wGfSQSadbfsFm0I9MOsW4Kvx4GwAvDeueAVwPjrfYn6dTdYpR+uLw17jONdVicsq6ZEob/bXw4zVDaaM/FH682bLA/vOs5UI2xLJ+TKdrlgCeIKOLsET8zh4ioyNYYP9N7QH7z7dbdGx06c/RLFIMq/KcZ/NHltrI6EJYjHYTDd+5NbS2qJuMNJXUhCQarJpKRtgXw6aSmphEg1XnkhGm0U0lNZZEg7mz3bcty+jmkhprosEqNxlhGV0sqQl9ZVaxwmTuMulan1eufsyJBqvcZIS1o4slNaHfkqzJCIsNgFeDY1bCYtVx+/ESeuqwJiMs/jjHa6POb+fYmri4/XgJNbp2MvLoHFv7cXWsROuEGl07Gbl3jq39uDpWWDonpCQjqfWI0w1h6WdMh9UPFWsyklJPAG4I/ZzTYfZDxZKMpOzkN4R+pnTY/VCJTUZCa3vQ+wjgHeL+P3rYzyZCJ0c/QghRk9iEJVSHNcPSReJjSVisOqwZFlY1n7Ck6LBmWFjVdMKSqsOaYWHu7CYTFoYOa4aFVdlmYawzI67RtWdYWJVtFiYlYWHosGZYWNVcwpJr9qS1xMdL7oSFlWi461pLfLzkTlhYiYZLa4mPl9wJS64korXEh0bNRGPsotpa4kOlRqJxzujYfljVVMLCSjR8Rof2w9zJVRMWVqJhMXqsn9qJzyil5zmmDPNxqfM2AJSDFUNGF+JSjfadW2d/lzDWxTBm3SzvElbD6B1meJewWkYfd/ZsTiM1jd6h4l3CZvMKH8g2e+Jjbka/rfXApY1+Jq2z6rw2rkumtNGs2ROrTnQywuJS7hLW2gxLNJdyl7DWZliah5XUsHS6hpHUMHW6JjWpYet0TUpSk0NHCCGEEEIIIYQQQgTyH92fTzcCuZbMAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitur2);
export default __webpack_public_path__ + "static/media/fitur2.fe74f0362dbbc157ca4be2a7592d5bd2.svg";
export { ForwardRef as ReactComponent };